<template>
<div>
  <div
    v-for="(company, index) in currentTerms"
    :key="index"
  >
    <input
      type="radio"
      :value="value"
      @input="$emit('input', company)"
      :checked="value === company"
    > {{ company.toUpperCase() }}
  </div>
</div>
</template>

<script>
export default {
  name: 'RadioCompaniesDocuments',
  props: ['currentTerms', 'value']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/RadioCompaniesDocuments.vue